import Text from 'components/Text/Text';
import { useLoggedUserRestaurants } from 'hooks/useLoggedUserRestaurants';
import React from 'react';
import style from './PositionsScrollableList.module.scss';

interface IPositionsScrollableListRestaurant {
	id: string;
	restaurantName: string | null;
	positionNumber: number;
}

interface IPositionsScrollableList {
	restaurants: IPositionsScrollableListRestaurant[];
}

const PositionsScrollableList: React.FC<IPositionsScrollableList> = ({ restaurants }) => {
	const accessibleRestaurants = useLoggedUserRestaurants(restaurants);

	return (
		<div className={style.container} data-test="RestaurantsPositionScrollView">
			{accessibleRestaurants.length
				? accessibleRestaurants.map((el) => (
						<div key={el.id} className={style.item}>
							<div className={style.dot} />
							<Text
								translationNameSpace="listing"
								translationKey="positionValue"
								components={[<span key="1" className={style.positionNumber} />]}
								values={{
									positionNumber: el.positionNumber,
									restaurantName: el.restaurantName,
								}}
								withTooltip={true}
							/>
						</div>
				  ))
				: '-'}
		</div>
	);
};

export default React.memo(PositionsScrollableList);
